(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expandable-grid"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.expandable-grid').forEach(function (grid) {
    var initialVisible = parseInt(grid.dataset.initialVisible, 10);
    var items = Array.from(grid.querySelectorAll('.expandable-grid__items > *'));
    var itemsEl = grid.querySelector('.expandable-grid__items');
    var toggle = grid.querySelector('.expandable-grid__toggle');
    var label = grid.querySelector('.expandable-grid__toggle-label');

    if (!toggle) return;

    if (items.length <= initialVisible) {
      toggle.closest('.expandable-grid__footer').style.display = 'none';
      return;
    }

    var extraItems = items.slice(initialVisible);

    extraItems.forEach(function (item) {
      item.setAttribute('hidden', '');
    });

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var nowExpanded = !expanded;

      toggle.setAttribute('aria-expanded', String(nowExpanded));
      label.textContent = nowExpanded ? toggle.dataset.hideLabel : toggle.dataset.showLabel;

      if (nowExpanded) {
        // Lock current height before adding items to layout
        var fromHeight = itemsEl.offsetHeight;
        extraItems.forEach(function (item) {
          item.removeAttribute('hidden');
          item.style.opacity = '0';
          item.style.transform = 'translateY(8px)';
        });
        var toHeight = itemsEl.scrollHeight;
        itemsEl.style.height = fromHeight + 'px';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            itemsEl.style.height = toHeight + 'px';
            extraItems.forEach(function (item, i) {
              item.style.transition = 'opacity 0.3s ease ' + (i * 25) + 'ms, transform 0.3s ease ' + (i * 25) + 'ms';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        });

        itemsEl.addEventListener('transitionend', function handler(e) {
          if (e.target !== itemsEl) return;
          itemsEl.style.height = '';
          extraItems.forEach(function (item) {
            item.style.transition = '';
            item.style.opacity = '';
            item.style.transform = '';
          });
          itemsEl.removeEventListener('transitionend', handler);
        });

      } else {
        // Fade out items, then collapse height
        var fadeDuration = 200 + (extraItems.length - 1) * 20;
        extraItems.forEach(function (item, i) {
          item.style.transition = 'opacity 0.2s ease ' + (i * 20) + 'ms, transform 0.2s ease ' + (i * 20) + 'ms';
          item.style.opacity = '0';
          item.style.transform = 'translateY(4px)';
        });

        setTimeout(function () {
          var fromHeight = itemsEl.offsetHeight;

          extraItems.forEach(function (item) {
            item.setAttribute('hidden', '');
            item.style.transition = '';
            item.style.opacity = '';
            item.style.transform = '';
          });

          var toHeight = itemsEl.scrollHeight;
          itemsEl.style.height = fromHeight + 'px';

          requestAnimationFrame(function () {
            itemsEl.style.height = toHeight + 'px';
          });

          itemsEl.addEventListener('transitionend', function handler(e) {
            if (e.target !== itemsEl) return;
            itemsEl.style.height = '';
            itemsEl.removeEventListener('transitionend', handler);
          });
        }, fadeDuration);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    const PRODUCT_DETAILS_TAB_DRAG_THRESHOLD = 6;

  function syncProductDetailsTabLabels(root) {
    const navList = root.querySelector('.product-details-tabs__nav-list');
    if (!navList) return;

    root.querySelectorAll('.product-details-tabs__nav .product-details-tabs__tab').forEach((navLabel) => {
      const source = root.querySelector(
        `.product-details-tabs__panels .product-details-tabs__tab[for="${navLabel.htmlFor}"]`
      );
      if (source) {
        const heading = source.textContent.trim();
        if (heading) navLabel.textContent = heading;
        navLabel.hidden = false;
      } else {
        navLabel.hidden = true;
      }
    });

    syncProductDetailsTabSelection(root);
  }

  function syncProductDetailsTabSelection(root) {
    const checked = root.querySelector('.product-details-tabs__input:checked');
    const navTabs = root.querySelectorAll('.product-details-tabs__nav .product-details-tabs__tab');
    let assigned = false;

    navTabs.forEach((navLabel) => {
      const selected = Boolean(checked) && !navLabel.hidden && navLabel.htmlFor === checked.id;
      navLabel.classList.toggle('is-selected', selected);
      if (selected) assigned = true;
    });

    if (!assigned) {
      const firstVisible = [...navTabs].find((navLabel) => !navLabel.hidden);
      if (firstVisible) firstVisible.classList.add('is-selected');
    }
  }

  function updateProductDetailsTabScrollable(nav) {
    nav.classList.toggle('is-scrollable', nav.scrollWidth > nav.clientWidth + 1);
  }

  function enableProductDetailsTabDrag(root) {
    const nav = root.querySelector('.product-details-tabs__nav');
    if (!nav || nav.dataset.dragBound === 'true') return;

    nav.dataset.dragBound = 'true';

    let pointerId = null;
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScrollLeft = 0;

    const endDrag = (event) => {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;

      const activePointerId = pointerId;
      const didMove = moved;

      pointerId = null;
      dragging = false;
      moved = false;
      nav.classList.remove('is-dragging');

      if (didMove) {
        nav.addEventListener(
          'click',
          (clickEvent) => {
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
          },
          { capture: true, once: true }
        );
      }

      if (nav.hasPointerCapture(activePointerId)) {
        nav.releasePointerCapture(activePointerId);
      }
    };

    nav.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (nav.scrollWidth <= nav.clientWidth + 1) return;

      pointerId = event.pointerId;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = nav.scrollLeft;
    });

    nav.addEventListener(
      'pointermove',
      (event) => {
        if (!dragging || event.pointerId !== pointerId) return;

        const deltaX = event.clientX - startX;
        if (!moved) {
          if (Math.abs(deltaX) < PRODUCT_DETAILS_TAB_DRAG_THRESHOLD) return;
          moved = true;
          nav.classList.add('is-dragging');
          nav.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        nav.scrollLeft = startScrollLeft - deltaX;
      },
      { passive: false }
    );

    nav.addEventListener('pointerup', endDrag);
    nav.addEventListener('pointercancel', endDrag);
    nav.addEventListener(
      'wheel',
      (event) => {
        if (nav.scrollWidth <= nav.clientWidth + 1) return;
        if (event.deltaX === 0 && event.deltaY === 0) return;

        const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        nav.scrollLeft += delta;
        event.preventDefault();
      },
      { passive: false }
    );

    updateProductDetailsTabScrollable(nav);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(() => updateProductDetailsTabScrollable(nav)).observe(nav);
    }

    window.addEventListener('resize', () => updateProductDetailsTabScrollable(nav));
  }

  function initProductDetailsTabs(root) {
    syncProductDetailsTabLabels(root);
    enableProductDetailsTabDrag(root);

    if (root.dataset.selectionBound === 'true') return;
    root.dataset.selectionBound = 'true';
    root.addEventListener('change', (event) => {
      if (event.target.matches('.product-details-tabs__input')) {
        syncProductDetailsTabSelection(root);
      }
    });
  }

  document.querySelectorAll('.product-details-tabs').forEach(initProductDetailsTabs);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.product-details-tabs').forEach(initProductDetailsTabs);
  });
  } catch(e) { console.error(e); }
})();

})();
